<template>
  <PopoverMenu @show="bindCardShortcuts" @hide="unbindShortcuts" data-test-id="card-menu">
    <template #trigger>
      <Btn icon color="ghost" data-test-id="card-menu-button" tabindex="-1">
        <MoreIcon16 />
      </Btn>
    </template>

    <template #items-list>
      <slot />
    </template>
  </PopoverMenu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { bindShortcuts } from '@/shortcuts';
import MoreIcon16 from '@components/Icons/MoreIcon16.vue';

export default defineComponent({
  emits: { confirm: null },
  name: 'CardMenu',

  components: {
    MoreIcon16,
  },

  data() {
    return {
      unbindShortcuts: () => {},
    };
  },

  methods: {
    bindCardShortcuts() {
      this.unbindShortcuts = bindShortcuts({
        confirm: (event) => {
          if (!('popoverMenuItem' in event.target.dataset)) {
            // do not trigger confirm if the key was pressed while focussed on menu item
            this.$emit('confirm');
          }
        },
      });
    },
  },

  beforeUnmount() {
    this.unbindShortcuts();
  },
});
</script>
